"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DailySignInviteBind = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var bindClient_1 = require("../../model/bindClient");
var service_1 = require("../../../library/base/service");
var DailySignInviteBind = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(DailySignInviteBind, _super);
    function DailySignInviteBind() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '每日签到邀请绑定手机号';
        _this.code = '300429';
        _this.desc = '每日签到邀请绑定手机号';
        _this.requestParams = new bindClient_1.InitRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return DailySignInviteBind;
}(service_1.BaseService));
exports.DailySignInviteBind = DailySignInviteBind;
//# sourceMappingURL=dailySignInviteBind.js.map